import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Confirm, Breadcrumb, Modal } from 'semantic-ui-react'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { MainBodyContent } from 'components'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import { appLoading } from 'ducks/app'
import { getVMFormData, clearVMFormData, updateVM, deleteVM, getWorkflow, checkTaxIdAvailable } from 'ducks/vendorMaintenance'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { checkAttachmentRequire } from '../AttributeData'
import { vmPath, vmDetailPath } from 'routes'
import { 
  AccountingForm, 
  ApproveForm, 
  AttachmentForm, 
  CommentHistory, 
  GeneralForm, 
  PurchasingForm, 
  RequestForm,
} from '../Form'
import { CertificateAttachmentForm } from '../../Suppliers/Form'
import { VendorMaintenanceContainer, VendorMaintenanceBody } from '../Form/styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'

const VendorMaintenanceEdit = (props) => {
  const { valueForm, formData, workflow } = props
  const [submit, setSubmit] = useState(false)
  const [mainFormClickSave, setMainFormClickSave] = useState(false)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [confirmMessage, setConfirmMessage] = useState('')
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    // props.getHrmsMembers(true)
    props.getAllMembers(true)
    props.getVMFormData(props.match.params.id, props.history)

    return () => {
      props.clearVMFormData()
    }
  }, [])

  useEffect(() => {
    if (formData.id) {
      if (formData.status !== undefined && formData.status !== null) {
        if (formData.status !== 0 && formData.status !== 5 && formData.status !== 10 && formData.status !== 11) {
          props.history.push(vmDetailPath(formData.id))
        }
      }
    }

    if (formData.status) {
      props.getWorkflow(props.match.params.id)
    }
  }, [formData])

  const onClickDelete = () => {

  }

  const onSubmitEditForm = (values) => {
    const { updateVM, history, appLoading, attachmentGroups } = props

    if (mainFormClickSave) {
      if (submit) {
        let errors = {}

        if (values.purpose === 'create' || values.purpose === 'change') {
          const documentTypes = attachmentGroups.data.find(a => a.bpGroup === values.accountGroup) || { attachments: [] }
          if (['ZDOV', 'ZFOV', 'ZRPT', 'ZRCP', 'ZOTV'].includes(values.accountGroup)) {
            if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
              if (values.notRegisterRemark === undefined || values.notRegisterRemark === null ||values.notRegisterRemark === '') {
                errors.notRegisterRemark = 'Required!'
              }
            }
          }

          if (values.paymentTypeTransfer) {
            if ((values.vendorBanks || []).length === 0) {
              errors.paymentType = ' Minimum 1 row of bank account required!'
            }

            if ((values.vendorUsers || []).length > 0) {
              if ((values.vendorUsers || []).filter(u => u.receiveChequeAtBank === true).length === 0) {
                errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
              }
            } else {
              errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
            }
          }

          documentTypes.attachments.forEach(d => {
            if (checkAttachmentRequire(d, values)) {
              if (((values[d.code] || []).length === 0) && ((values[`attachment${d.code.replace('VMA', '')}`] || []).length === 0)) {
                errors[d.code] = 'Require!'
              }
            }
          })

          if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'create') {
            validations(values, 'reconciliationAccount', [vCase.require], errors)
            validations(values, 'sortKey', [vCase.require], errors)
            validations(values, 'planningGroup', [vCase.require], errors)
            validations(values, 'accPaymentTerms', [vCase.require], errors)
            validations(values, 'paymentMethod', [vCase.require], errors)
            validations(values, 'tradingPartner', [vCase.require], errors)
            validations(values, 'branchCode', [vCase.require], errors)
            validations(values, 'branchDescription', [vCase.require], errors)
          }
      
          if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'change' && values.accountingViewLoaded === true) {
            validations(values, 'reconciliationAccount', [vCase.require], errors)
            validations(values, 'sortKey', [vCase.require], errors)
            validations(values, 'planningGroup', [vCase.require], errors)
            validations(values, 'accPaymentTerms', [vCase.require], errors)
            validations(values, 'paymentMethod', [vCase.require], errors)
            validations(values, 'tradingPartner', [vCase.require], errors)
            validations(values, 'branchCode', [vCase.require], errors)
            validations(values, 'branchDescription', [vCase.require], errors)
          }
        }

        if (values.purpose === 'copy') {
          validations(values, 'copyType', [vCase.require], errors)
      
          if (values.copyType === 'company') {
            if ((values.companies || []).length === 0) {
              errors.companies = 'Require!'
            }
          }
      
          if (values.copyType === 'purchasingOrg') {
            validations(values, 'purchasingOrg', [vCase.require], errors)
      
            if (values.purchasingOrg) {
              if ((values.copyPurchasingOrg || []).length === 0) {
                errors.copyPurchasingOrg = 'Require!'
              }
            }
          }
        }

        if (values.purpose === 'create' || values.purpose === 'copy') {
          if ((['ZDOV', 'ZFIN', 'ZOTV', 'ZRPT', 'ZRCP'].includes(values.accountGroup) && values.paymentTypeTransfer)) {
            if (values.receiveEWht === null || values.receiveEWht === undefined) {
              errors.receiveEWht = 'Require!'
            }
          }
        }

        if (Object.keys(errors).length) {
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          const { purpose, vendorCode, vendorType, taxId, accountGroup } = values
          if ((purpose === 'create' || purpose === 'change') && accountGroup !== 'ZFOV') {
            props.checkTaxIdAvailable(
              { vendorCode, vendorType, taxId, accountGroup }, 
              () => { updateVM(values, submit, history, appLoading) }, 
              (message) => {
                if (message.startsWith('Tax ID has been created by Business Partner E') && accountGroup === 'ZEMP' && (vendorCode || '').length !== 6) {
                  setShowErrorModal(true)
                  setErrorMessage(message)
                } else {
                  setShowConfirmModal(true)
                  setConfirmMessage(message)
                }
              }
            )
          } else {
            updateVM(values, submit, history, appLoading)
          }
        }
      } else {
        let errors = {}

        if (values.purpose === 'create' || values.purpose === 'change') {
          if (['ZDOV', 'ZFOV', 'ZRPT', 'ZRCP', 'ZOTV'].includes(values.accountGroup)) {
            if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
              if (values.notRegisterRemark === undefined || values.notRegisterRemark === null ||values.notRegisterRemark === '') {
                errors.notRegisterRemark = 'Required!'
              }
            }
          }
  
          if (values.paymentTypeTransfer) {
            if ((values.vendorBanks || []).length === 0) {
              errors.paymentType = ' Minimum 1 row of bank account required!'
            }

            if ((values.vendorUsers || []).length > 0) {
              if ((values.vendorUsers || []).filter(u => u.receiveChequeAtBank === true).length === 0) {
                errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
              }
            } else {
              errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
            }
          }
        }

        if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'create') {
          validations(values, 'reconciliationAccount', [vCase.require], errors)
          validations(values, 'sortKey', [vCase.require], errors)
          validations(values, 'planningGroup', [vCase.require], errors)
          validations(values, 'accPaymentTerms', [vCase.require], errors)
          validations(values, 'paymentMethod', [vCase.require], errors)
          validations(values, 'tradingPartner', [vCase.require], errors)
          validations(values, 'branchCode', [vCase.require], errors)
          validations(values, 'branchDescription', [vCase.require], errors)
        }
    
        if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'change' && values.accountingViewLoaded === true) {
          validations(values, 'reconciliationAccount', [vCase.require], errors)
          validations(values, 'sortKey', [vCase.require], errors)
          validations(values, 'planningGroup', [vCase.require], errors)
          validations(values, 'accPaymentTerms', [vCase.require], errors)
          validations(values, 'paymentMethod', [vCase.require], errors)
          validations(values, 'tradingPartner', [vCase.require], errors)
          validations(values, 'branchCode', [vCase.require], errors)
          validations(values, 'branchDescription', [vCase.require], errors)
        }

        if (values.purpose === 'copy') {
          validations(values, 'copyType', [vCase.require], errors)
      
          if (values.copyType === 'company') {
            if ((values.companies || []).length === 0) {
              errors.companies = 'Require!'
            }
          }
      
          if (values.copyType === 'purchasingOrg') {
            validations(values, 'purchasingOrg', [vCase.require], errors)
      
            if (values.purchasingOrg) {
              if ((values.copyPurchasingOrg || []).length === 0) {
                errors.copyPurchasingOrg = 'Require!'
              }
            }
          }
        }

        if (values.purpose === 'create' || values.purpose === 'copy') {
          if ((['ZDOV', 'ZFIN', 'ZOTV', 'ZRPT', 'ZRCP'].includes(values.accountGroup) && values.paymentTypeTransfer)) {
            if (values.receiveEWht === null || values.receiveEWht === undefined) {
              errors.receiveEWht = 'Require!'
            }
          }
        }

        if (Object.keys(errors).length) {
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          updateVM(values, submit, history, appLoading)
        }
      }
      setMainFormClickSave(false)
    }
  }

  const editableForm = () => {
    if (formData.status !== 0) {
      return (formData.sn !== undefined && formData.sn !== null && formData.sn !== '')
    } else {
      return true
    }
  }

  return (
    <MainBodyContent 
    headerTitle={formData.documentNumber ? `Vendor Maintenance - Edit (${formData.documentNumber})` : 'Vendor Maintenance - Edit'}
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'VM', content: 'Vendor Maintenance', link: true, onClick: () => props.history.push(vmPath) },
              { key: 'VMEdit', content: 'Edit', active: true }
            ]
          }
        />
      }
    >
      <VendorMaintenanceContainer>
        {
          formData.status ? 
            <DocumentStep documentDetail={formData} approvers={workflow.data} /> : null
        }
        <VendorMaintenanceBody>
          <form onSubmit={props.handleSubmit((values) => onSubmitEditForm(values))}>
            <RequestForm change={props.change} valueForm={valueForm} />
            <GeneralForm change={props.change} valueForm={valueForm} />
            {
              valueForm.purpose === 'block' || 
              valueForm.purpose === 'copy' ||
              valueForm.accountGroup === 'ZEMP' ? null : 
                <PurchasingForm change={props.change} valueForm={valueForm}/>
            }
            {
              (valueForm.accountGroup === 'ZRPT'||valueForm.accountGroup === 'ZRCP') && (valueForm.purpose === 'create' || valueForm.purpose === 'change') ? 
                <AccountingForm change={props.change} valueForm={valueForm}/> : null
            }
            {
              valueForm.purpose === 'block' || !valueForm.isFromVendor? null : valueForm.vendorType=='company'?
                <CertificateAttachmentForm change={props.change} valueForm={valueForm}/>:null
            }
            {
              valueForm.purpose === 'block' || valueForm.purpose === 'copy' ? null : 
                <AttachmentForm change={props.change} valueForm={valueForm}/>
            }
            {
              formData && formData.comments && formData.comments.length ? <CommentHistory /> : null
            }
            {
              formData.sn ? 
                <ApproveForm history={props.history} handleSubmit={props.handleSubmit} /> :
                valueForm.status === 0 ||valueForm.status === 11 ?
                  <div className='btnContainer'>
                    {valueForm.isFromVendor&&valueForm.purpose=='change'?null:
                    <div className='left'>
                      <Button
                        type='button'
                        content='Delete'
                        color='red'
                        icon='trash'
                        labelPosition='right'
                        style={{ marginRight: '5px' }}
                        onClick={() => {
                          setShowDeleteConfirm(true)
                        }}
                      />
                    </div>}
                    <div className='right'>
                      <Button
                        type='submit'
                        content='Save'
                        icon='save'
                        labelPosition='right'
                        style={{ marginRight: '5px' }}
                        onClick={() => {
                          setMainFormClickSave(true)
                          setSubmit(false)
                        }}
                      />
                      <Button
                        type='submit'
                        content='Save & Submit'
                        color='blue'
                        icon='save'
                        labelPosition='right'
                        style={{ marginRight: '5px' }}
                        onClick={() => {
                          setMainFormClickSave(true)
                          setSubmit(true)
                        }}
                      />
                    </div>
                  </div> : null
            }
          </form>
        </VendorMaintenanceBody>
      </VendorMaintenanceContainer>
      <Confirm
        open={showDeleteConfirm}
        cancelButton='Cancel'
        confirmButton='Delete'
        header='Vendor Maintenance'
        content='Do you want to delete document?'
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={() => {
          props.deleteVM(valueForm.id, props.history, () => setShowDeleteConfirm(false))
        }}
      />
      <Confirm 
        open={showConfirmModal}
        header='Warning!'
        content={
          <div style={{ padding: '1.25rem' }}>
            <p>{confirmMessage}</p>
            {
              valueForm.purpose === 'create' ?
                <p>Are you sure to create new Business Partner Code?</p> :
              valueForm.purpose === 'change' ?
                <p>Are you sure to change Business Partner Data?</p> : null
            }
          </div>
        }
        confirmButton='Yes'
        cancelButton='No'
        onConfirm={() => {
          setShowConfirmModal(false)
          props.updateVM(valueForm, submit, props.history, props.appLoading)
        }}
        onCancel={() => setShowConfirmModal(false)}
      />
      <Modal
        open={showErrorModal}
        onClose={() => setShowErrorModal(false)}
      >
        <Modal.Header>Can't Submit Business Partner!</Modal.Header>
        <Modal.Content>
          {errorMessage}
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  // const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  const vf = getFormValues('formVendorMaintenance')(state) || {}
  const fd = state.vendorMaintenance.formData.data

  const getValue = (key) => {
    return vf[key] !== undefined ? vf[key] : fd[key]
  }

  var initialValues = {
    id: fd.id,
    title: getValue('title'),
    requesterUser: getValue('requesterUser'),
    requesterName: getValue('requesterName'),
    createdBy: getValue('createdBy'),
    documentDate: getValue('documentDate'),
    documentNumber: getValue('documentNumber'),
    status: getValue('status'),
    remark: getValue('remark'),
    purpose: getValue('purpose'),
    copyType: getValue('copyType'),
    vendorCode: getValue('vendorCode'),
    accountGroup: getValue('accountGroup'),
    companyCode: getValue('companyCode'),
    companyName: getValue('companyName'),
    companies: getValue('companies'),
    vendorType: getValue('vendorType'),
    vendorName1: getValue('vendorName1'),
    vendorName2: getValue('vendorName2'),
    vendorName3: getValue('vendorName3'),
    vendorName4: getValue('vendorName4'),
    searchName: getValue('searchName'),
    industry: getValue('industry'),
    standardIndustry: getValue('standardIndustry'),
    taxId: getValue('taxId'),
    isGovernment: getValue('isGovernment'),
    country: getValue('country'),
    province: getValue('province'),
    district: getValue('district'),
    subDistrict: getValue('subDistrict'),
    houseNumber: getValue('houseNumber'),
    buildingOrRoomNo: getValue('buildingOrRoomNo'),
    street: getValue('street'),
    postalCode: getValue('postalCode'),
    notRegisterRemark: getValue('notRegisterRemark'),
    vendorUsers: getValue('vendorUsers'),
    paymentTypeTransfer: getValue('paymentTypeTransfer'),
    paymentTypeCheque: getValue('paymentTypeCheque'),
    paymentTypeTtlc: getValue('paymentTypeTtlc'),
    vendorBanks: getValue('vendorBanks'),
    copyPurchasingOrg: getValue('copyPurchasingOrg'),
    usePurchasingView: getValue('usePurchasingView'),
    purchasingOrg: getValue('purchasingOrg'),
    orderCurrency: getValue('orderCurrency'),
    paymentTerms: getValue('paymentTerms'),
    salePerson: getValue('salePerson'),
    salePersonTelephone: getValue('salePersonTelephone'),
    incoterm: getValue('incoterm'),
    incotermsLocation: getValue('incotermsLocation'),
    grBasedInvoiceVerification: getValue('grBasedInvoiceVerification'),

    attachment01: getValue('attachment01'),
    attachment02: getValue('attachment02'),
    attachment03: getValue('attachment03'),
    attachment04: getValue('attachment04'),
    attachment05: getValue('attachment05'),
    attachment06: getValue('attachment06'),
    attachment07: getValue('attachment07'),
    attachment08: getValue('attachment08'),
    attachment09: getValue('attachment09'),
    attachment10: getValue('attachment10'),
    attachment11: getValue('attachment11'),
    attachment12: getValue('attachment12'),
    attachment13: getValue('attachment13'),
    attachment14: getValue('attachment14'),
    attachment15: getValue('attachment15'),
    attachment16: getValue('attachment16'),
    attachment17: getValue('attachment17'),

    reconciliationAccount: getValue('reconciliationAccount'),
    sortKey: getValue('sortKey'),
    planningGroup: getValue('planningGroup'),
    accPaymentTerms: getValue('accPaymentTerms'),
    paymentMethod: getValue('paymentMethod'),
    paymentBlock: getValue('paymentBlock'),
    tradingPartner: getValue('tradingPartner'),
    previousAccount: getValue('previousAccount'),
    checkDoubleInvoice: getValue('checkDoubleInvoice'),
    payeeInDocument: getValue('payeeInDocument'),
    withholdingTaxs: getValue('withholdingTaxs'),
    branches: getValue('branches'),
    branchCode: getValue('branchCode'),
    branchDescription: getValue('branchDescription'),

    sn: getValue('sn'),
    actions: getValue('actions'),
    submittedDate: getValue('submittedDate'),
    modifiedDate: getValue('modifiedDate'),

    purchasingViewLoaded: getValue('purchasingViewLoaded'),
    accountingViewLoaded: getValue('accountingViewLoaded'),

    centralBlock: getValue('centralBlock'),
    allPurchasingBlock: getValue('allPurchasingBlock'),
    blockAllCompany: getValue('blockAllCompany'),
    blockCompanies: getValue('blockCompanies'),
    isFromVendor: getValue('isFromVendor'),
    mobile: getValue('mobile'),
    telephone: getValue('telephone'),
    extension: getValue('extension'),
    website: getValue('website'),
    totalValueOfCurrentProject: getValue('totalValueOfCurrentProject'),
    totalValueOfCurrentProjectCurrency: getValue('totalValueOfCurrentProjectCurrency'),
    listDealer: getValue('listDealer'),
    typeOfBusiness: getValue('typeOfBusiness'),
    typeOfBusinessOther: getValue('typeOfBusinessOther'),
    typeOfVendor: getValue('typeOfVendor'),
    receiveEWht: getValue('receiveEWht')
  }

  const blockCompanies = getValue('blockCompanies') || []

  blockCompanies.forEach(c => {
    initialValues[`block_${c}`] = vf[`block_${c}`] !== undefined ? vf[`block_${c}`] : true
  })

  return ({
    valueForm: vf,
    formData: fd,
    workflow: state.vendorMaintenance.workflow,
    attachmentGroups: state.vendorMaintenance.attachmentGroups,
    initialValues
  })
}

const mapDispatchToProps = {
  getVMFormData,
  clearVMFormData,
  updateVM,
  appLoading,
  deleteVM,
  getWorkflow,
  checkTaxIdAvailable,
  getHrmsMembers,
  getAllMembers
}

const validate = (values) => {
  let errors = {}
  validations(values, 'title', [vCase.require, vCase.maxLength200], errors)
  validations(values, 'requesterUser', [vCase.require], errors)
  validations(values, 'documentDate', [vCase.require], errors)
  validations(values, 'purpose', [vCase.require], errors)
  validations(values, 'accountGroup', [vCase.require], errors)

  if (values.purpose === 'create' || values.purpose === 'change') {
    validations(values, 'companyCode', [vCase.require], errors)
    validations(values, 'vendorType', [vCase.require], errors)
    validations(values, 'vendorName1', [vCase.require, vCase.maxLength40], errors)
    validations(values, 'vendorName2', [vCase.maxLength40], errors)
    validations(values, 'vendorName3', [vCase.maxLength40], errors)
    validations(values, 'vendorName4', [vCase.maxLength40], errors)
    validations(values, 'searchName', [vCase.require, vCase.maxLength20], errors)

    validations(values, 'industry', [vCase.require], errors)
    if (values.purpose !== 'block') {
      if (values.accountGroup === 'ZFOV') {
        validations(values, 'taxId', [vCase.maxLength13], errors)
      } else {
        validations(values, 'taxId', [vCase.require, vCase.maxLength13], errors)
      }
    }
    validations(values, 'country', [vCase.require], errors)
    validations(values, 'province', [vCase.require], errors)
    validations(values, 'district', [vCase.require], errors)
    validations(values, 'subDistrict', [vCase.require], errors)
    validations(values, 'houseNumber', [vCase.require, vCase.maxLength10], errors)
    validations(values, 'buildingOrRoomNo', [vCase.require, vCase.maxLength60], errors)
    validations(values, 'street', [vCase.maxLength40], errors)
    validations(values, 'postalCode', [vCase.require, vCase.maxLength10], errors)

    if (['ZDOV', 'ZFOV', 'ZRPT', 'ZRCP', 'ZOTV'].includes(values.accountGroup)) {
      if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
        validations(values, 'notRegisterRemark', [vCase.require], errors)
      }
    }

    if (values.paymentTypeTransfer) {
      if ((values.vendorBanks || []).length === 0) {
        errors.paymentType = ' Minimum 1 row of bank account required!'
      }

      if ((values.vendorUsers || []).length > 0) {
        if ((values.vendorUsers || []).filter(u => u.receiveChequeAtBank === true).length === 0) {
          errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
        }
      } else {
        errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
      }
    }

    if (values.usePurchasingView) {
      if (values.purpose === 'create' || values.purpose === 'change') {
        validations(values, 'purchasingOrg', [vCase.require], errors)
      }

      validations(values, 'orderCurrency', [vCase.require], errors)
      validations(values, 'paymentTerms', [vCase.require], errors)

      if (values.incoterm !== undefined && values.incoterm !== null && values.incoterm !== '') {
        validations(values, 'incotermsLocation', [vCase.require], errors)
      }
    }

    if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'create') {
      validations(values, 'reconciliationAccount', [vCase.require], errors)
      validations(values, 'sortKey', [vCase.require], errors)
      validations(values, 'planningGroup', [vCase.require], errors)
      validations(values, 'accPaymentTerms', [vCase.require], errors)
      validations(values, 'paymentMethod', [vCase.require], errors)
      validations(values, 'tradingPartner', [vCase.require], errors)
      validations(values, 'branchCode', [vCase.require], errors)
      validations(values, 'branchDescription', [vCase.require], errors)
    }

    if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'change' && values.accountingViewLoaded === true) {
      validations(values, 'reconciliationAccount', [vCase.require], errors)
      validations(values, 'sortKey', [vCase.require], errors)
      validations(values, 'planningGroup', [vCase.require], errors)
      validations(values, 'accPaymentTerms', [vCase.require], errors)
      validations(values, 'paymentMethod', [vCase.require], errors)
      validations(values, 'tradingPartner', [vCase.require], errors)
      validations(values, 'branchCode', [vCase.require], errors)
      validations(values, 'branchDescription', [vCase.require], errors)
    }
  }

  if (values.purpose === 'copy') {
    validations(values, 'copyType', [vCase.require], errors)

    if (values.copyType === 'company') {
      if ((values.companies || []).length === 0) {
        errors.companies = 'Require!'
      }
    }

    if (values.copyType === 'purchasingOrg') {
      validations(values, 'purchasingOrg', [vCase.require], errors)

      if (values.purchasingOrg) {
        if ((values.copyPurchasingOrg || []).length === 0) {
          errors.copyPurchasingOrg = 'Require!'
        }
      }
    }
  }

  if (values.purpose === 'create' || values.purpose === 'copy') {
    if ((['ZDOV', 'ZFIN', 'ZOTV', 'ZRPT', 'ZRCP'].includes(values.accountGroup) && values.paymentTypeTransfer)) {
      if (values.receiveEWht === null || values.receiveEWht === undefined) {
        errors.receiveEWht = 'Require!'
      }
    }
  }

  return errors
}

const VendorMaintenanceEditForm = reduxForm({
  form: 'formVendorMaintenance',
  enableReinitialize: true,
  validate,
  onSubmitFail: scrollToFirstValidateFailElement
})(VendorMaintenanceEdit)

export default connect(mapStateToProps, mapDispatchToProps)(VendorMaintenanceEditForm)
